module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-cyrillic485.ba43f2e.woff2";